import { ref } from "vue";
import { defineStore } from "pinia";
import useMyFetch from "@stores/useMyFetch";
import handleError from "@utils/composables/handleError";

export const useBidderTargetsStore = defineStore("bidderTargets", () => {
  //state
  const bidderStatus = ref([]);
  const bidderTargets = ref([]);
  // actions
  async function fetchBidderTargets(mCampaignToken) {
    try {
      const { response: reponse_bidder, data: data_bidder } = await useMyFetch(
        `/bidder_runs/${mCampaignToken}/last`,
      ).json();
      if (reponse_bidder.value.ok) {
        bidderTargets.value = data_bidder.value.bidder_targets;
        bidderStatus.value = data_bidder.value.bidder_status;
      }
      return bidderTargets.value;
    } catch (err) {
      handleError(err);
    }
  }

  const pProgressGlobal = () => {
    if (!bidderTargets.value || bidderTargets.value.length === 0) {
      return 0;
    }
    const { numerator_progress, denominator_progress } = bidderTargets.value.reduce(
      (acc, target) => {
        const { n, b_pdays, b_pn_daily, n_target } = target;
        acc.numerator_progress += n + b_pdays * b_pn_daily;
        acc.denominator_progress += n_target;
        return acc;
      },
      { numerator_progress: 0, denominator_progress: 0 },
    );
    return denominator_progress === 0 ? 0 : (numerator_progress / denominator_progress).toFixed(2);
  };

  const pProgress = (target) => {
    return target.n + target.b_pdays * target.b_pn_daily;
  };
  const pTimeGlobal = () => {
    if (!bidderTargets.value || bidderTargets.value.length === 0) {
      return 0;
    }
    return Math.max(...bidderTargets.value.map((target) => target.b_pdays)).toFixed(2);
  };

  const pMarginGlobal = () => {
    if (!bidderTargets.value || bidderTargets.value.length === 0) {
      return 0;
    }
    const { numerator_margin, denominator_margin } = bidderTargets.value.reduce(
      (acc, target) => {
        const { b_pcpi, b_pn_daily, cpi } = target;
        acc.numerator_margin += b_pcpi * b_pn_daily;
        acc.denominator_margin += b_pn_daily * cpi;
        return acc;
      },
      { numerator_margin: 0, denominator_margin: 0 },
    );
    return denominator_margin === 0 ? 0 : (1 - numerator_margin / denominator_margin).toFixed(2);
  };
  return {
    bidderTargets,
    bidderStatus,
    fetchBidderTargets,
    pProgressGlobal,
    pProgress,
    pTimeGlobal,
    pMarginGlobal,
  };
});
